import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import {
  activeSlateAtom,
  showCompletedAtom,
  completedFilterAtom,
  slatesAtom,
} from "../../store/atoms/filterAtoms.js";
import { hasRunAtom } from "../../store/atoms/taskAtoms.js";

// Filter State Hook
export const useFilters = () => {
  const [activeSlate, setActiveSlate] = useAtom(activeSlateAtom);
  const [showCompleted, setShowCompleted] = useAtom(showCompletedAtom);
  const [completedFilter, setCompletedFilter] = useAtom(completedFilterAtom);
  const slates = useAtomValue(slatesAtom);
  const setHasRun = useSetAtom(hasRunAtom);

  const handleSlateChange = useCallback(
    (direction) => {
      if (direction === "prev") {
        setActiveSlate((prev) => (prev - 1 + slates.length) % slates.length);
        setHasRun(false);
      } else if (direction === "next") {
        setActiveSlate((prev) => (prev + 1) % slates.length);
        setHasRun(false);
      }
    },
    [setActiveSlate, slates.length, setHasRun]
  );

  return {
    activeSlate,
    setActiveSlate,
    showCompleted,
    setShowCompleted,
    completedFilter,
    setCompletedFilter,
    slates,
    handleSlateChange,
  };
};
